import type {
  ContentDetailsRequestConfig,
  PortalContentKind,
} from "../../@types/portalAluno";
import { isPortalContentKind } from "../../utils/portalAluno/contentKinds";

const CONTENT_CONFIG: ContentDetailsRequestConfig = {
  actionType: "CONTEUDOS",
  aboutTitle: "Sobre o conteúdo",
  childKey: "conteudosRelacionados",
  dateKey: "dtConteudoInicio",
  descriptionKey: "dsConteudo",
  endpoint: "mobile/conteudo",
  entityType: "conteudo",
  idKey: "idConteudo",
  imageKey: "imgConteudo",
  listTitle: "Conteúdos relacionados",
  moduleRoute: "/app",
  moduleTitle: "Conteúdos",
  paramKey: "idConteudo",
  shareKey: "urlCompartilhamentoConteudo",
  titleKey: "nmConteudo",
};

export const CONTENT_DETAILS_CONFIG: Record<
  PortalContentKind,
  ContentDetailsRequestConfig
> = {
  conteudos: CONTENT_CONFIG,
  destaques: {
    ...CONTENT_CONFIG,
    aboutTitle: "Sobre o destaque",
    listTitle: "Conteúdos relacionados",
    moduleRoute: "/app/conteudo/destaques",
    moduleTitle: "Destaques",
  },
  "biblioteca-multimidia": {
    ...CONTENT_CONFIG,
    aboutTitle: "Sobre a multimídia",
    moduleRoute: "/app/biblioteca/multimidia",
    moduleTitle: "Multimídia",
  },
  "biblioteca-documentos": {
    ...CONTENT_CONFIG,
    aboutTitle: "Sobre o documento",
    moduleRoute: "/app/biblioteca/documentos",
    moduleTitle: "Documentos",
  },
  "biblioteca-games": {
    ...CONTENT_CONFIG,
    aboutTitle: "Sobre o game",
    moduleRoute: "/app/biblioteca/games",
    moduleTitle: "Simuladores & Games",
  },
  cursos: {
    actionType: "CURSOS",
    aboutTitle: "Sobre o curso",
    childKey: "cursoConteudos",
    dateKey: "dtCursoInicio",
    descriptionKey: "dsCurso",
    endpoint: "mobile/curso",
    entityType: "curso",
    evaluationKey: "cursoAvaliacoes",
    idKey: "idCurso",
    imageKey: "imgCurso",
    listTitle: "Conteúdos do Curso",
    moduleRoute: "/app/conteudo/cursos",
    moduleTitle: "Cursos",
    paramKey: "idCurso",
    progressBasis: "contents",
    shareKey: "urlCompartilhamentoCurso",
    titleKey: "nmCurso",
  },
  trilhas: {
    actionType: "TRILHAS",
    aboutTitle: "Sobre a trilha",
    childKey: "trilhaCursos",
    dateKey: "dtTrilhaInicio",
    descriptionKey: "dsTrilha",
    endpoint: "mobile/trilha",
    entityType: "trilha",
    evaluationKey: "trilhaAvaliacoes",
    idKey: "idTrilha",
    imageKey: "imgTrilha",
    listTitle: "Cursos da Trilha",
    moduleRoute: "/app/conteudo/trilhas",
    moduleTitle: "Trilhas",
    paramKey: "idTrilha",
    progressBasis: "coursesAndEvaluations",
    shareKey: "urlCompartilhamentoTrilha",
    titleKey: "nmTrilha",
  },
  "treinamentos-de-1-ponto": {
    actionType: "T1",
    aboutTitle: "Sobre o treinamento",
    childKey: "cursoT1Conteudos",
    dateKey: "dtCursoT1Inicio",
    descriptionKey: "dsCursoT1",
    endpoint: "mobile/t1",
    entityType: "t1",
    evaluationKey: "cursoT1Avaliacoes",
    idKey: "idCursoT1",
    imageKey: "imgCursoT1",
    listTitle: "Conteúdos do Treinamento",
    moduleRoute: "/app/conteudo/treinamentos-de-1-ponto",
    moduleTitle: "Treinamentos de 1 ponto",
    paramKey: "idT1",
    progressBasis: "contentsAndEvaluations",
    shareKey: "urlCompartilhamentoCursoT1",
    titleKey: "nmCursoT1",
  },
  comunicados: {
    actionType: "COMUNICADOS",
    aboutTitle: "Sobre o comunicado",
    childKey: "cursoComunicadoConteudos",
    dateKey: "dtCursoComunicadoInicio",
    descriptionKey: "dsCursoComunicado",
    endpoint: "mobile/comunicado",
    entityType: "comunicado",
    evaluationKey: "cursoComunicadoAvaliacoes",
    idKey: "idCursoComunicado",
    imageKey: "imgCursoComunicado",
    listTitle: "Conteúdos do Comunicado",
    moduleRoute: "/app/conteudo/comunicados",
    moduleTitle: "Comunicados",
    paramKey: "idComunicado",
    progressBasis: "contentsAndEvaluations",
    shareKey: "urlCompartilhamentoCursoComunicado",
    titleKey: "nmCursoComunicado",
  },
  "seguranca-do-trabalho": {
    actionType: "SEGURANCAS",
    aboutTitle: "Sobre segurança do trabalho",
    childKey: "segurancaNoTrabalhoConteudos",
    dateKey: "dtSegurancaNoTrabalhoInicio",
    descriptionKey: "dsSegurancaNoTrabalho",
    endpoint: "mobile/segurancaNoTrabalho",
    entityType: "seguranca",
    evaluationKey: "segurancaNoTrabalhoAvaliacoes",
    idKey: "idSegurancaNoTrabalho",
    imageKey: "imgSegurancaNoTrabalho",
    listTitle: "Conteúdos da Campanha",
    moduleRoute: "/app/conteudo/seguranca-do-trabalho",
    moduleTitle: "Segurança do trabalho",
    paramKey: "idSegurancaNoTrabalho",
    progressBasis: "contentsAndEvaluations",
    shareKey: "urlCompartilhamentoSegurancaNoTrabalho",
    titleKey: "nmSegurancaNoTrabalho",
  },
};

export const getContentDetailsConfig = (sourceType?: unknown) =>
  isPortalContentKind(sourceType)
    ? CONTENT_DETAILS_CONFIG[sourceType]
    : undefined;
